"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function ShoppingBagIcon(_a) {
    var _b = _a.height, height = _b === void 0 ? "24px" : _b, _c = _a.color, color = _c === void 0 ? "currentColor" : _c, style = _a.style, className = _a.className;
    return (react_1.default.createElement("svg", { height: height, className: className, style: style, viewBox: "0 0 32 32" },
        react_1.default.createElement("path", { fill: color, d: "M26,9.9A1,1,0,0,0,25,9H22V8A6,6,0,0,0,10,8V9H7a1,1,0,0,0-1,.9L4.24,26.69a3,3,0,0,0,3,3.31H24.78a3,3,0,0,0,3-3.31ZM12,8a4,4,0,0,1,8,0V9H12ZM25.52,27.67a1,1,0,0,1-.74.33H7.22a1,1,0,0,1-1-1.1L7.9,11H24.1l1.67,15.9A1,1,0,0,1,25.52,27.67ZM22,14a6,6,0,0,1-12,0,1,1,0,0,1,2,0,4,4,0,0,0,8,0,1,1,0,0,1,2,0Z" })));
}
exports.default = ShoppingBagIcon;
//# sourceMappingURL=index.js.map